export const PATH_CREATE_FORM = '/';
export const PATH_DEMO = '/form/demo/fields';
export const PATH_EDITFIELDS_FORM = '/form/:formId/fields';
export const PATH_DATA_FORM = '/form/:formId/data';
export const PATH_BLOCKS_FORM = '/form/:formId/blocks';
export const PATH_VIEW_FORM = '/form/:formId/view';
export const PATH_SETTINGS_FORM = '/form/:formId/settings';
export const PATH_PREVIEW_FORM = '/form/:formId/preview';
export const PATH_CONTRIBUTE_FORM = '/contribute/project/:projectId';
export const PATH_CONTRIBUTE_REVIEW_FORM = '/contribute/review/:projectId';
// v3 only - Not used today (allows the notation of a task)
export const PATH_CONTRIBUTE_MARK = '/contribute/mark/:taskId';
// :taskId here can be a "hitId" for v5
export const PATH_CONTRIBUTE_VIEW_FORM = '/contribute/view/:taskId';
// v5 only -> used to view the final answer for a given TaskLine
export const PATH_CONTRIBUTE_TASKLINE_ANSWER = '/contribute/answer/:taskLineId';
export const PATH_CERTIFICATION_FORM = '/contribute/certification/:certificationId';
// v5 only -> allows a manager to publish the reference answer for a given certification question
export const PATH_CERTIFICATION_PUBLISH_QUESTION =
  '/contribute/certification/:certificationId/question/:questionId';
// v5 only -> allows a manager to view the answer of a candidate for a given certification question
export const PATH_CERTIFICATION_VIEW =
  '/contribute/certificationUserTest/:certificationUserTestId/question/:questionId';
export const PATH_INFO_FORM = '/form/:formId/information';
export const PATH_QUALITY_FORM = '/form/:formId/quality';
export const PATH_VALIDATION_FORM = '/form/:formId/quality/validation';
export const PATH_RESPONDANTS_FORM = '/form/:formId/quality/respondants';
export const PATH_STRATEGY_FORM = '/form/:formId/strategy';
export const PATH_FIELD_NO_COMPARE = '/form/:formId/quality/fields-no-compare';
export const PATH_FIELD_TO_COMPARE = '/form/:formId/quality/fields-to-compare';
export const PATH_BLOCKS_SORTING = '/form/:formId/quality/blocks-sorting';
export const PATH_KEYBOARD_SHORTCUTS = '/form/:formId/quality/keyboard-shortcuts';
export const PATH_ADVANCED_FIELD_TO_COMPARE = '/form/:formId/quality/advanced-fields-to-compare';
export const PATH_ITERATION_OVERLOAD = '/form/:formId/quality/iteration-overload';

export const PATHS_QUALITY = [
  PATH_QUALITY_FORM,
  PATH_RESPONDANTS_FORM,
  PATH_VALIDATION_FORM,
  PATH_FIELD_NO_COMPARE,
  PATH_FIELD_TO_COMPARE,
  PATH_BLOCKS_SORTING,
];

// Paths displaying the edition drawer next to the WYSIWYG grid
export const PATHS_WITH_DRAWER = [
  PATH_EDITFIELDS_FORM,
  PATH_DATA_FORM,
  PATH_BLOCKS_FORM,
  PATH_SETTINGS_FORM,
  PATH_INFO_FORM,
  PATH_QUALITY_FORM,
  PATH_RESPONDANTS_FORM,
  PATH_STRATEGY_FORM,
  PATH_VALIDATION_FORM,
  PATH_FIELD_NO_COMPARE,
  PATH_FIELD_TO_COMPARE,
  PATH_BLOCKS_SORTING,
  PATH_KEYBOARD_SHORTCUTS,
  PATH_ADVANCED_FIELD_TO_COMPARE,
  PATH_ITERATION_OVERLOAD,
];

// Paths displaying the information panel and its toggle button
export const PATHS_WITH_INFO = [
  PATH_PREVIEW_FORM,
  PATH_EDITFIELDS_FORM,
  PATH_DATA_FORM,
  PATH_SETTINGS_FORM,
  PATH_INFO_FORM,
  PATH_BLOCKS_FORM,
  PATH_QUALITY_FORM,
  PATH_RESPONDANTS_FORM,
  PATH_STRATEGY_FORM,
  PATH_CONTRIBUTE_FORM,
  PATH_CERTIFICATION_FORM,
  PATH_CONTRIBUTE_MARK,
  PATH_CONTRIBUTE_REVIEW_FORM,
  PATH_CONTRIBUTE_VIEW_FORM,
  PATH_FIELD_NO_COMPARE,
  // v5 only, details above
  PATH_CONTRIBUTE_TASKLINE_ANSWER,
  PATH_CERTIFICATION_PUBLISH_QUESTION,
  PATH_CERTIFICATION_VIEW,
];

// Paths displaying the task details inside the information panel
export const PATHS_WITH_TASK_INFO = [
  PATH_CONTRIBUTE_FORM,
  PATH_CONTRIBUTE_MARK,
  PATH_CONTRIBUTE_REVIEW_FORM,
  PATH_CONTRIBUTE_VIEW_FORM,
  PATH_CERTIFICATION_FORM,
];
